import {  postRequest } from '@/libs/axios';
export const getCustomerList = (params) => {
    return postRequest('/ndt/module/customer/page', params)
}

export const getCustomerDetail = (params) => {
    return postRequest('/ndt/module/customer/detail', params)
}
export const getCustomerOrderList = (params) => {
    return postRequest('/ndt/module/customer/order/page', params)
}
export const getCustomerOrderDetail = (params) => {
    return postRequest('/ndt/module/customer/order/detail', params)
}

export const customerOrderStatistics = (params) => {
    return postRequest('/ndt/module/customer/order/statistics', params)
}

// 授权客户相关API
export const getAuthorizeUserList = (params) => {
    return postRequest('/ndt/authorize/user/page', params)
}

export const addAuthorizeUser = (params) => {
    return postRequest('/ndt/authorize/user/add', params)
}

export const updateAuthorizeUser = (params) => {
    return postRequest('/ndt/authorize/user/update', params)
}

export const deleteAuthorizeUser = (params) => {
    return postRequest('/ndt/authorize/user/delete', params)
}

export const updateAuthorizeUserStatus = (params) => {
    return postRequest('/ndt/authorize/user/updateStatus', params)
}
